<div class="d-flex align-items-stretch h-100">
  <nav class="d-flex text-bg-primary">
    <ul class="nav flex-column w-100">
      <li class="nav-item close-btn-container">
        <a href="#" (click)="activeOffcanvas.dismiss(null)" class="nav-link">
          <i class="bi-arrow-left-circle"></i>
          <span>Dismiss</span>
        </a>
      </li>
      <li class="nav-item">
        <a
          href="#"
          (click)="onOpenClicked()"
          class="nav-link"
          [ngClass]="{ active: activeComponent === fileMenuActions.Open }">
          <i class="bi-folder2-open"></i>
          <span>Open</span>
        </a>
      </li>
      <li class="nav-item">
        <a
          href="#"
          (click)="onNewClicked()"
          class="nav-link"
          [ngClass]="{ active: activeComponent === fileMenuActions.New }">
          <i class="bi-file-earmark-plus"></i>
          <span>New</span>
        </a>
      </li>
      <li class="nav-item">
        <a href="#" (click)="onSaveClicked()" class="nav-link">
          <i class="bi-file-earmark-check"></i>
          <span>Save</span>
        </a>
      </li>
      <li class="nav-item">
        <a
          href="#"
          (click)="onSaveAsClicked()"
          class="nav-link"
          [ngClass]="{ active: activeComponent === fileMenuActions.SaveAs }">
          <i class="bi-file-earmark-check"></i>
          <span>Save As</span>
        </a>
      </li>
      <li class="nav-item">
        <a href="#" (click)="printDocument()" class="nav-link">
          <i class="bi-printer"></i>
          <span>Print</span>
        </a>
      </li>
      <li class="nav-item">
        <a
          href="#"
          (click)="onDownloadClicked()"
          class="nav-link"
          [ngClass]="{ active: activeComponent === fileMenuActions.Download }">
          <i class="bi-download"></i>
          <span>Download</span>
        </a>
      </li>
      <li class="nav-item">
        <a
          href="#"
          (click)="onUploadClicked()"
          class="nav-link"
          [ngClass]="{ active: activeComponent === fileMenuActions.Upload }">
          <i class="bi-upload"></i>
          <span>Upload</span>
        </a>
      </li>
      <li class="nav-item">
        <a href="#" (click)="onCloseClicked()" class="nav-link">
          <i class="bi-folder-x"></i>
          <span>Close</span>
        </a>
      </li>
      <li class="nav-item">
        <a [routerLink]="'/sessions'" [target]="'_blank'" class="nav-link">
          <span>Active Documents</span>
        </a>
      </li>
    </ul>
  </nav>

  <div class="p-4 overflow-auto flex-fill">
    <ng-container *ngIf="activeComponent === fileMenuActions.New">
      <tx-new-document (newDocumentSelected)="openNewDocument($event)"></tx-new-document>
    </ng-container>
    <ng-container *ngIf="activeComponent === fileMenuActions.Open">
      <tx-open-document
        (openDocument)="openDocument($event)"
        (openInNewTab)="openDocumentInNewTab($event)"
        (uploadDocument)="uploadDocument($event)"
        [existingDocument]="document.pathname"
        [isPdf]="isPdf"
        [isDirty]="isDirty"></tx-open-document>
    </ng-container>
    <ng-container *ngIf="activeComponent === fileMenuActions.SaveAs">
      <tx-save-as
        (saveAs)="saveDocumentAs($event)"
        (save)="onSaveClicked()"
        (download)="downloadDocument($event)"
        [existingDocument]="document.pathname"
        [document]="document"
        [isPdf]="isPdf"></tx-save-as>
    </ng-container>
    <ng-container *ngIf="activeComponent === fileMenuActions.Upload">
      <tx-upload-document (uploadDocument)="uploadDocument($event)"></tx-upload-document>
    </ng-container>
    <ng-container *ngIf="activeComponent === fileMenuActions.Download">
      <tx-download-document (downloadDocument)="downloadDocument($event)" [isPdf]="isPdf"></tx-download-document>
    </ng-container>
  </div>
</div>
